module.exports = __webpack_public_path__ + "static/media/btn-icon-1.8e51409d.png";